import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { RadioProps } from '@hh.ru/magritte-ui-checkbox-radio/types';
import { IncompleteSkeletonComponent, Skeleton } from '@hh.ru/magritte-ui-skeleton';

import styles from './radio.less';

export const RadioSkeleton: IncompleteSkeletonComponent<RadioProps> = ({
    Component: Radio,

    // skeleton props
    width,
    height,
    borderRadius,
    inline,
    additionalClass,
    loading,

    ...radioProps
}) => {
    const isLoading = useLoadingState() || loading;

    if (isLoading) {
        return (
            <div className={styles.radioSkeletonContainer}>
                <Skeleton additionalClass={styles.radioSkeleton} loading={isLoading} />
            </div>
        );
    }

    return <Radio {...radioProps} />;
};
